var _module = require('../module');

require('angular-ui-router');
require('../window-height');
require('../../services/lr-touch');

_module.requires.push('ui.router');

_module.component('deviceAuthSuccess', {
    controllerAs: 'das',
    controller: [
        '$log',

        function deviceAuthSuccessCtrl($log) {
            $log.debug('Device Auth Success');
        }
    ],
    template: require('./index.html')
});
